import { render } from "./MatrixUploaderSimce.vue?vue&type=template&id=23116d2a&scoped=true"
import script from "./MatrixUploaderSimce.vue?vue&type=script&lang=js"
export * from "./MatrixUploaderSimce.vue?vue&type=script&lang=js"

import "./MatrixUploaderSimce.vue?vue&type=style&index=0&id=23116d2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23116d2a"]])

export default __exports__